import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { draftRecord } from '../../form/create/draftRecord';
import { InlineField } from '../../fields/InlineField';
import type { ISubTableDraftRowProps } from './ISubTableDraftRowProps';

/**
 * Новий рядок підтаблиці, якому ще бракує обов'язкових значень (прототип v4: рядок з'являється одразу після «+ Додати»): ті самі клітинки,
 * завжди редаговані; зміна клітинки зберігає рядок, щойно обов'язкові поля заповнено; × відкидає його. Позначений акцентною смугою.
 */
export function SubTableDraftRow({ ws, moduleKey, child, values, fields, grid, onChange, onDiscard }: ISubTableDraftRowProps) {
  const { t } = useTranslation();
  const record = useMemo(() => ({ ...draftRecord(child, moduleKey, values, ''), id: `new-${child.key}` }), [child, moduleKey, values]);
  return (
    <div className="rec-subcard__row rec-subcard__row--draft" style={grid} title={t('recordPage.general.draftRow')}>
      {fields.map((f) => (
        <span key={f.key} className="rec-subcard__cell">
          <InlineField field={f} rt={child} ws={ws} record={record} value={values[f.key] ?? null}
            emptyChoice={t('recordPage.general.emptyCell')} onCommit={(v) => onChange(f.key, v)} />
        </span>
      ))}
      <button type="button" className="rec-subcard__x" aria-label={t('recordPage.general.discardRow')} title={t('recordPage.general.discardRow')} onClick={onDiscard}>×</button>
    </div>
  );
}
